export const extractName = (text?: string | null) => {
  return (text ?? "").replaceAll(/｜*[^｜_]*_/g, "｜").replace("｜", "")
}
